var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrows1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 138.8 15.5",
    style: {
      enableBackground: "new 0 0 138.8 15.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;fill:#D177B8;}\n\t.st2{fill:url(#SVGID_00000093179353764838471150000000599731332601542583_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.6145,
    y1: 7.76,
    x2: 138.7745,
    y2: 7.76
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B34349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2740"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.8,15.4c-0.4-0.5-3.1-3.1-12.8-4.1c-3.5-0.4-8.2,0-12.9,0.5c-9.9,1.2-20,3.7-20,3.7s-5.6-2.3-8.5-9.5h1.1 c0,0,2.5,4.6,5.6,6.9L87,6.1c0,0,6.2-0.2,16.7-1.5c10.5-1.3,18-4,18-4L121.2,0c0,0,0.1,0,0.1,0C122.5,0.5,131.4,3.8,138.8,15.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.8,15.4c-0.4-0.5-3.1-3.1-12.8-4.1c-3.5-0.4-8.2,0-12.9,0.5c14.4-3.5,16.3-3.4,16.3-3.4 c-3.2-6.2-7.3-8.1-8-8.4C122.5,0.5,131.4,3.8,138.8,15.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066486874188585949380000004974330025237511577_",
    gradientUnits: "userSpaceOnUse",
    x1: -1163.1078,
    y1: 7.76,
    x2: -1108.9478,
    y2: 7.76,
    gradientTransform: "matrix(-1 0 0 1 -1108.9478 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B34349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2740"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066486874188585949380000004974330025237511577_)"
    },
    d: "M0,15.4c0.4-0.5,3.1-3.1,12.8-4.1 c3.5-0.4,8.2,0,12.9,0.5c9.9,1.2,20,3.7,20,3.7s5.6-2.3,8.5-9.5h-1.1c0,0-2.5,4.6-5.5,6.9l4.2-6.9c0,0-6.2-0.2-16.7-1.5 c-10.5-1.3-18-4-18-4L17.6,0c0,0-0.1,0-0.1,0C16.2,0.5,7.4,3.8,0,15.4z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,15.4c0.4-0.5,3.1-3.1,12.8-4.1c3.5-0.4,8.2,0,12.9,0.5C11.3,8.4,9.4,8.4,9.4,8.4c3.2-6.2,7.2-8.1,8-8.4 C16.2,0.5,7.4,3.8,0,15.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrows1);
export default __webpack_public_path__ + "static/media/Brows1.f3853376dc87e609bcb9ac28df42cb19.svg";
export { ForwardRef as ReactComponent };